/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_4af52718"]'><cube-button outline primary scope="phoneNumber" tip="需在小程序环境下预览" @getPhoneNumber='(e)=>__invoke(e, [["onGetPhoneNumber"]])'>获取手机号</cube-button></div></template>
/* styles */
/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_4af52718"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_4af52718"}
  /** script content **/
  require("./btn-get-phone-number.mpx.js?isComponent&outputPath=components%2Fbtn-get-phone-number4af52718%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./btn-get-phone-number.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fbtn-get-phone-number4af52718%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_4af52718"],
    ctorType: "component",
    outputPath: "components/btn-get-phone-number4af52718/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-button':getComponent(require("../../../packages/mpx-cube-ui/src/components/button/index.mpx?isComponent&outputPath=components%2Findex7752a2b9%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>